<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card outlined class="notification-card">
          <v-card-text class="pa-4 pa-sm-6">

            <!-- Título -->
            <div class="notification-header mb-6 d-none d-sm-flex">
              <span class="notification-title">Notificações</span>
            </div>

            <!-- Tabs + Botão -->
            <div class="notification-controls mb-6">
              <div class="notification-tabs">
                <button
                  :class="['tab-btn', { 'tab-btn--active': filter === 'unread' }]"
                  @click="filter = 'unread'"
                >
                  <v-icon small class="mr-1" :color="filter === 'unread' ? '#907ff5' : '#d1cee0'">
                    mdi-check
                  </v-icon>
                  Não Lidos
                </button>
                <button
                  :class="['tab-btn', { 'tab-btn--active': filter === 'read' }]"
                  @click="filter = 'read'"
                >
                  <v-icon small class="mr-1" :color="filter === 'read' ? '#907ff5' : '#d1cee0'">
                    mdi-check
                  </v-icon>
                  Lidos
                </button>
              </div>

              <button class="mark-all-btn" @click="markAllNotificationsAsRead()">
                <span class="mark-all-btn__text">MARCAR TODOS</span>
              </button>
            </div>

            <!-- Lista de notificações -->
            <app-pagination @click="select($event)" :data="notifications">
              <div class="notification-list">
                <div
                  v-for="notification in filteredNotifications"
                  :key="notification.id"
                  :class="['notification-item', { 'notification-item--unread': !notification.read_at }]"
                  @click="markNotificationAsRead(notification)"
                >
                  <!-- Ícone -->
                  <div class="notification-icon">
                    <v-icon size="20" color="#7a7786">
                      {{ notification.data.icon || 'mdi-bell-outline' }}
                    </v-icon>
                  </div>

                  <!-- Conteúdo -->
                  <div class="notification-content">
                    <span
                      :class="['notification-content__title', { 'notification-content__title--unread': !notification.read_at }]"
                    >
                      {{ notification.data.title }}
                    </span>
                    <span class="notification-content__desc">
                      {{ notification.data.message }}
                    </span>
                  </div>

                  <!-- Meta (data + ícone lido) -->
                  <div class="notification-meta">
                    <span class="notification-meta__date d-none d-sm-inline">
                      {{ $format.dateRelative(notification.created_at) }}
                    </span>
                    <v-icon
                      size="24"
                      :color="!notification.read_at ? '#907ff5' : '#d1cee0'"
                    >
                      {{ !notification.read_at ? 'mdi-check-circle' : 'mdi-check-circle-outline' }}
                    </v-icon>
                  </div>
                </div>

                <div v-if="filteredNotifications.length === 0" class="no-notifications">
                  <v-icon size="40" color="#d1cee0">mdi-bell-off-outline</v-icon>
                  <p>Nenhuma notificação encontrada</p>
                </div>
              </div>
            </app-pagination>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    filter: 'unread',
  }),

  mounted() {
    this.select();
  },

  computed: {
    notifications() {
      return this.$store.state.notification.notifications;
    },

    filteredNotifications() {
      const data = this.notifications.data || [];
      if (this.filter === 'unread') {
        return data.filter((n) => !n.read_at);
      }
      return data.filter((n) => !!n.read_at);
    },
  },

  methods: {
    markAllNotificationsAsRead() {
      this.$loading.start();
      this.$store
        .dispatch('notification/markAllNotificationsAsRead')
        .then(() => {
          this.select();
        })
        .catch(() => {
          this.$loading.finish();
        });
    },

    markNotificationAsRead(notification) {
      if (notification.read_at == null) {
        this.$loading.start();
        this.$store
          .dispatch('notification/markNotificationAsRead', notification.id)
          .then(() => {
            this.select();
            this.$loading.finish();
          })
          .catch(() => {
            this.$loading.finish();
          });
      }
    },

    select(page = 1) {
      this.$loading.start();
      this.$store
        .dispatch('notification/getNotifications', page)
        .then(() => {
          this.$loading.finish();
        })
        .catch(() => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style scoped>
.notification-card {
  border-radius: 16px !important;
}

/* Título */
.notification-header {
  display: flex;
  align-items: center;
}

.notification-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  color: #33303e;
}

/* Controles (tabs + botão) */
.notification-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.notification-tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  display: flex;
  align-items: center;
  height: 37px;
  padding: 8px 14px;
  border-radius: 100px;
  border: 1.5px solid #ebebf5;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #d1cee0;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-btn--active {
  background: #f4f4fb;
  border-color: transparent;
  color: #907ff5;
}

.mark-all-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 12px 32px;
  border-radius: 100px;
  border: 1.5px solid #d1cee0;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #33303e;
  cursor: pointer;
  transition: background 0.2s;
}

.mark-all-btn:hover {
  background: #f4f4fb;
}

/* Lista */
.notification-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.notification-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.notification-item--unread {
  background: rgba(244, 242, 254, 0.32);
}

.notification-item:hover {
  background: rgba(144, 127, 245, 0.08);
}

/* Ícone */
.notification-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f2fe;
  border: 1.5px dashed #ebebf5;
  border-radius: 100px;
}

/* Conteúdo */
.notification-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.notification-content__title {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #4e4b59;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notification-content__title--unread {
  color: #907ff5;
}

.notification-content__desc {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #8c8a97;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Meta */
.notification-meta {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification-meta__date {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #aaa8b8;
  white-space: nowrap;
}

/* Vazio */
.no-notifications {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
  color: #aaa8b8;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
}

/* ── Responsivo ── */

/* Mobile (< 600px) */
@media (max-width: 599px) {
  .notification-card {
    border: none !important;
    box-shadow: none !important;
  }

  .notification-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .mark-all-btn {
    width: 100%;
    justify-content: center;
    height: 40px;
    padding: 8px 20px;
    font-size: 13px;
  }

  .notification-item {
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
  }

  .notification-icon {
    width: 36px;
    height: 36px;
  }

  .notification-content__title {
    font-size: 14px;
    white-space: normal;
  }

  .notification-content__desc {
    font-size: 13px;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  .notification-meta {
    align-self: flex-start;
    margin-top: 2px;
  }
}

/* Tablet (600px – 959px) */
@media (min-width: 600px) and (max-width: 959px) {
  .notification-content__desc {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
}
</style>
